<script>
	import { scaleAdOnHover, startAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// FLU-0211-Sonnenziele-300x600-DDL-ovk
		muchachos: {
			element: false,
			fallbackImgUrl: './../commercial/11.Ueberflieger/04.reiseziele/Sonnenziele-300x600/fallback.webp',
			imageAltText: 'Sonnenziele - interactive Ad',
			iframeIndexUrl: './../commercial/11.Ueberflieger/04.reiseziele/Sonnenziele-300x600/index.html',
			playTimeMs: 32000,
			playing: false,
			autoStopTimeOut: false,
			scale: 1,
			maxScale: 1,
			origWidth: 300,
			origHeight: 600
		},
		// FLU-0211-Sonnenziele-300x600-DDL-ovk
		eyesOnAirplane: {
			element: false,
			fallbackImgUrl: './../commercial/11.Ueberflieger/04.reiseziele/Sonnenziele-300x600/fallback.webp',
			imageAltText: 'Sonnenziele - interactive Ad',
			iframeIndexUrl: './../commercial/11.Ueberflieger/04.reiseziele/Sonnenziele-300x600/index.html',
			playTimeMs: 12332000,
			// playTimeMs: 32000,
			playing: false,
			autoStopTimeOut: false,
			scale: 1,
			origHeight: 600
		},
		// zebra-827_flu0260-drs-bundle-corendon_320x100_default
		corendon: {
			element: false,
			fallbackImgUrl: './../commercial/11.Ueberflieger/04.reiseziele/corendon-320x100/backup.webp',
			iframeIndexUrl: './../commercial/11.Ueberflieger/04.reiseziele/corendon-320x100/index.html',
			playTimeMs: 32000,
			playing: true,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			maxScale: 1,
			origWidth: 320,
			origHeight: 100
		},
		// zebra-827_flu0260-drs-bundle-sundair_320x100_default
		sundair: {
			element: false,
			fallbackImgUrl: './../commercial/11.Ueberflieger/04.reiseziele/sundair-320x100/backup.webp',
			iframeIndexUrl: './../commercial/11.Ueberflieger/04.reiseziele/sundair-320x100/index.html',
			playTimeMs: 32000,
			playing: true,
			autoplay: true,
			scale: 1,
			maxScale: 1,
			origWidth: 320,
			origHeight: 100
		},
		// zebra-827_flu0260-drs-bundle-laudamotion_320x100_default
		laudamotion: {
			element: false,
			fallbackImgUrl: './../commercial/11.Ueberflieger/04.reiseziele/laudamotion-320x100/backup.webp',
			iframeIndexUrl: './../commercial/11.Ueberflieger/04.reiseziele/laudamotion-320x100/index.html',
			playTimeMs: 32000,
			playing: true,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			maxScale: 1,
			origWidth: 320,
			origHeight: 100
		}
	}
</script>

<div class="page-tourism-reiseziele marginbox">
	<div class="flex structure">
		<div class="flex row structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Überflieger - Desktop - Ad-Design" src="./../img/11.Ueberflieger/04.reiseziele/desktop.webp">
			</div>
		</div>


		<div class="flex row structure-2">
			<div class="flex element flex-326 eyesOnAirplane">
				<!-- Beginning - Ad: Eyes on Airplane -->
				<div bind:this={ads.eyesOnAirplane.element} class="content"
					 style="
					 --scale: {ads.eyesOnAirplane.scale};
					 --origWidth: {ads.eyesOnAirplane.origWidth || 0}px;
					 --origHeight: {ads.eyesOnAirplane.origHeight || 0}px;
				">
					{#if ads.eyesOnAirplane.playing}
						<div class="commercial" class:playing={ads.eyesOnAirplane.playing}>
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.eyesOnAirplane.iframeIndexUrl}
									style="--bg-image: url('{ads.eyesOnAirplane.fallbackImgUrl}')"
									on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
						</div>
					{:else}
						<div use:scaleAdOnHover class="commercial" class:playing={ads.eyesOnAirplane.playing} on:click={() => startAd(ads.eyesOnAirplane, () => ads = ads)}>
							<!-- NOT PLAYING -->
							<img loading="lazy" alt={ads.eyesOnAirplane.imageAltText} src={ads.eyesOnAirplane.fallbackImgUrl}/>
							<button aria-label="play Ad - {ads.eyesOnAirplane.imageAltText}" class="playbutton"></button>
						</div>
					{/if}
				</div>
				<!-- End - Ad: Wikana Skyscraper -->
			</div>
			<div class="flex element flex-652">
				<img loading="lazy" alt="Überflieger - Firefighter - Ad-Design" src="./../img/11.Ueberflieger/04.reiseziele/FLU0295A_GDN_Ad_firefighter_quadratisch_B.webp">
			</div>
			<div class="flex element flex-326">
				<img loading="lazy" alt="Überflieger - Muchacho - Ad-Design"
					 src="./../img/11.Ueberflieger/04.reiseziele/muchacho.webp">
			</div>
		</div>
		<div class="flex col structure-3">
			<div class="flex element flex-640 aspect-640-360">
				<img loading="lazy" alt="Überflieger - Firefighter - Ad-Design" src="./../img/11.Ueberflieger/04.reiseziele/FLU0229_Videowall_19201080_Ferner_Osten_K3.webp">
			</div>

			<div class="flex element flex-285">
				<div class="text">
					<h2 class="caption">{getText("11.04.01_h2")}</h2>
					<p class="caption">{getText("11.04.02_caption")}</p>
					<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
				</div>
			</div>
			<div class="flex element col flex-auto">
				<div class="flex element corendon">
					<!-- Beginning - Ad: Corendon -->
					<div bind:this={ads.corendon.element} class="content"
						 style="
							 --scale: {ads.corendon.scale};
							 --origWidth: {ads.corendon.origWidth || 0}px;
							 --origHeight: {ads.corendon.origHeight || 0}px;
						">
						<div class="commercial noscale" class:playing={ads.corendon.playing}>
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.corendon.iframeIndexUrl} on:load={() => startAd(ads.corendon, () => ads = ads)}
									style="--bg-image: url('{ads.corendon.fallbackImgUrl}')"
									on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
						</div>
					</div>
					<!-- End - Ad -->
				</div>
				<div class="flex element sundair">
					<!-- Beginning - Ad: Sundair -->
					<div bind:this={ads.sundair.element} class="content"
						 style="
							 --scale: {ads.sundair.scale};
							 --origWidth: {ads.sundair.origWidth || 0}px;
							 --origHeight: {ads.sundair.origHeight || 0}px;
						">
						<div class="commercial noscale" class:playing={ads.sundair.playing}>
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.sundair.iframeIndexUrl} on:load={() => startAd(ads.sundair, () => ads = ads)}
									style="--bg-image: url('{ads.sundair.fallbackImgUrl}')"
									on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
						</div>
					</div>
					<!-- End - Ad -->
				</div>
				<div class="flex element laudamotion">
					<!-- Beginning - Ad: Laudamotion -->
					<div bind:this={ads.laudamotion.element} class="content"
						 style="
							 --scale: {ads.laudamotion.scale};
							 --origWidth: {ads.laudamotion.origWidth || 0}px;
							 --origHeight: {ads.laudamotion.origHeight || 0}px;
						">
						<div class="commercial noscale" class:playing={ads.laudamotion.playing}>
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.laudamotion.iframeIndexUrl} on:load={() => startAd(ads.laudamotion, () => ads = ads)}
									style="--bg-image: url('{ads.laudamotion.fallbackImgUrl}')"
									on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
						</div>
					</div>
					<!-- End - Ad -->
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";

	.commercial {
		position: relative;

		width: 100%;
		height: 100%;
	}

	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}

	iframe {
		border: none;
		background-image: var(--bg-image);
		background-size: cover;
	}

	:global(iframe[loaded]) {
		background-image: none !important;
	}

	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}

	h2 {
		margin-bottom: $media-gap;

		&.caption {
			@include font-px-to-rem(22, 28, 600);
		}
	}

	p.caption {
		@include font-px-to-rem(22, 28, 300);
	}

	.page-tourism-reiseziele {
		.flex {
			display: flex;
			box-sizing: border-box;
		}

		.row {
			flex-flow: row wrap;
		}

		.col {
			flex-flow: column;
			height: 100%;
			gap: 20px;
			align-self: flex-start;
		}

		.element {
			min-width: 100px;
		}

		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
			line-height: 0;
		}

		.corendon, .sundair, .laudamotion {
			.commercial {
				height: calc(var(--origHeight) * var(--scale));
			}
		}

		.content {
			flex: 1;
		}

		.structure {
			flex-flow: row wrap;
		}

		.structure-1 {
			width: 100%;
			padding: 0;
			position: relative;

			.element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;

				&.eyesOnAirplane, &.firefighter, &.corendon, &.sundair, &.laudamotion {
					height: 100%;
					margin-bottom: 0;
					align-items: end;

					.content {
						max-width: 100%;
					}
					iframe {
						transform-origin: top left;
						scale: var(--scale);
						height: var(--origHeight);
						width: var(--origWidth);
					}
				}
				&.firefighter {
					iframe {
						scale: 1;
						height: var(--origHeight);
						width: var(--origWidth);
						transform-origin: top left;
					}
				}
			}
		}

		.structure-2 {
			aspect-ratio: 2 / 1;

			.flex.element {
				height: 100%;
				
				.content {
					overflow: hidden;
				}

				&.eyesOnAirplane {
					iframe {
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						width: auto;
					}
				}

				> img, > .content, .commercial > img {
					height: 100%;
				}
			}

			@include for-phone-only {
				aspect-ratio: 1 / 5;
				margin-bottom: -1.65rem !important;

				.flex.element {
					flex: unset;

					&.flex-326 {
						height: calc(40% - 1.25em);
					}
					&.flex-652 {
						height: calc(20% - 1.25em);
					}
				}
			}
		}

		.structure-2, .structure-3 {
			width: 100%;
			gap: $media-gap;
			margin-bottom: $media-gap;
			flex-direction: row;

			@include for-phone-only {
				flex-direction: column;

				.element {
					width: 100%;
				}
			}

			.flex-auto {
				flex: auto;
			}
			.flex-285 {
				flex: 285;
			}
			.flex-320 {
				flex: 320;
			}
			.flex-326 {
				flex: 326;
			}
			.flex-652 {
				flex: 652;
			}
			.flex-640 {
				flex: 640;
			}
			.flex-auto,
			.flex-285,
			.flex-320,
			.flex-326,
			.flex-652,
			.flex-640 {
				img {
					height: fit-content;
				}
			}


			.element {
				&.eyesOnAirplane, &.firefighter {
					height: 100%;
					margin-bottom: 0;
					align-items: end;

					.content {
						max-width: 100%;
					}
					iframe {
						transform-origin: top left;
						scale: var(--scale);
						height: var(--origHeight);
						width: var(--origWidth);
					}
				}
				&.eyesOnAirplane {
					iframe {
						scale: var(--scale);
					}
				}
				&.firefighter {
					iframe {
						scale: 1;
						height: var(--origHeight);
						width: var(--origWidth);
						transform-origin: top left;
					}
				}
				&.aspect-640-360 {
					display: block;

					img {
						aspect-ratio: 640 / 360;
					}
				}
			}
		}

		.text {
			margin: 0;
		}
	}
</style>
